<template>
  <v-flex xs12 pt-0 mt-1 style="cursor: pointer" @click.stop.prevent="toogleView">
    <v-divider style="margin-bottom: 6px;" />
    <v-layout row wrap>
      <v-flex xs2 py-0>
      </v-flex>
      <v-flex xs10 py-0>
        <v-container py-0 px-0>
          <v-layout row wrap>
            <v-flex xs8>
              <v-layout row wrap body-1>
                <v-flex xs12 py-0>
                  {{record.company_name}}
                </v-flex>
                <v-flex xs12 py-0>
                  {{l(record.value, record.currency)}} {{i18n('convertidos para')}} {{l(record.exchanged_value, record.exchange_currency)}}
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs4 py-0 text-xs-right>
              <v-layout row wrap caption>
                <v-flex xs12 py-0>
                  {{record.currency}} => {{record.exchange_currency}}
                </v-flex>
                <v-flex xs12 py-0>
                  {{humanMovementDate}}
                </v-flex>
              </v-layout>
            </v-flex>

            <transition name="fade">
              <v-flex xs12 v-if="current_view === 'detailed'">
                <v-layout row wrap body-1>
                  <v-flex xs12 py-0>
                    {{record.source_name}} {{record.source_document_type.toUpperCase()}}: {{record.source_document_number}}
                  </v-flex>
                  <v-flex xs12 py-0>
                    {{i18n('Banco')}} {{record.source_bank}} {{i18n('Agência')}} {{record.source_branch}} {{i18n('Conta')}} {{record.source_account}}
                  </v-flex>
                  <v-flex xs12 py-0>
                    {{i18n('Origem')}} {{record.source}} ID {{record.source_type}}-{{record.source_id}}
                  </v-flex>
                  <v-flex xs12 py-0>
                    IOF {{l(record.iof_value, record.currency)}}
                    FX {{l(record.fx_value, record.currency)}}
                  </v-flex>
                </v-layout>
              </v-flex>
            </transition>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-flex>
</template>
<script>

import utils from "./shared/Utils"

export default {
  name: 'ExchangeTransactionItem',
  props: {
    record: {
      type: Object
    }
  },
  data() {
    return {
      current_view: 'short'
    }
  },
  computed: {
    humanMovementDate() {
      return utils.dbDateToHuman(this.record.movement_date)
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    toogleView() {
      this.current_view = (this.current_view === 'short') ? 'detailed' : 'short'
    },
    l(number_value, currency) {
      return utils.currencyToLocal(number_value, currency)
    }
  },
  mounted() {
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/ExchangeTransactionItem.vue